import { PentestScan } from '../pentest-scan';
import { PentestStatistics } from '../pentest-statistics';
import { Sort } from '../sort.data';
import { Box } from '../box';
import { PentestScanResultSummary } from '../pentest-scan-result-summary';
import { BoxStatus } from '../box-status.data';
import { Customer } from '../customer';
import { PentestScanPageRequest } from '../pentest-scan-page-request.data';
import { BoxPageRequest } from '../box-page-request.data';
import { SortDirection } from '../../enums';
import { Asset } from '../asset';
import { CustomerPentestStatistics } from '../customer-pentest-statistics';

export interface DashboardState {
  selectedCustomer: Customer | null;
  customerPentestScanStatistics: CustomerPentestStatistics[];
  pentestStatistics: PentestStatistics;
  statisticsLoading: boolean;
  pentestScans: PentestScan[];
  pentestScanResults: { [key: string]: PentestScanResultSummary };
  pentestScanPageRequest: PentestScanPageRequest;
  scansLoading: boolean;
  scansMoreLoading: boolean;
  boxes: Box[];
  boxStatuses: { [key: string]: BoxStatus };
  boxPageRequest: BoxPageRequest;
  boxesLoading: boolean;
  pentestReportsLoading: string[];
  allBoxes: Box[];
  assets: Asset[];
  isDataSharingInitialized: boolean | null;
}

export const initialDashboardState: DashboardState = {
  selectedCustomer: null,
  customerPentestScanStatistics: [],
  pentestStatistics: {
    metrics: [
      {
        label: 'dashboard.metrics.internalPentests',
        value: 0,
        icon: 'cloud_download',
        iconSize: 1.625,
      },
      {
        label: 'dashboard.metrics.totalUniqueHosts',
        value: 0,
        icon: 'dns',
        iconSize: 1.5,
      },
      {
        label: 'dashboard.metrics.externalScans',
        value: 0,
        icon: 'cloud_upload',
        iconSize: 1.625,
      },
      {
        label: 'dashboard.metrics.hostsInLargestPentest',
        value: 0,
        icon: 'bar_chart',
        iconSize: 2,
      },
    ],
    lastestImpacts: [],
    lastestWeaknesses: [],
    lastestCredentials: [],
  },
  statisticsLoading: true,
  pentestScans: [],
  pentestScanResults: {},
  pentestScanPageRequest: {
    page: 0,
    size: 20,
    sort: {} as Sort,
    searchText: '',
  },
  scansLoading: true,
  scansMoreLoading: false,
  boxes: [],
  boxStatuses: {},
  boxPageRequest: {
    page: 0,
    size: 20,
    sort: { sortBy: 'state', direction: SortDirection.Desc },
  },
  boxesLoading: true,
  pentestReportsLoading: [],
  allBoxes: [],
  assets: [],
  isDataSharingInitialized: null,
};
